import { fetchCA } from 'helpers/utils'

export const apiFetchAdminLinks = () => fetchCA(`/links`)
export const apiFetchUserLinks = (user) => fetchCA(`/links`, { user })
export const deleteUserLinkApi = ({ id, user }) => {
  return fetchCA(`/links`, { id, user }, 'DELETE')
}

export const addUserLinkApi = ({ user, link }) => {
  return fetchCA(`/links`, { user }, 'POST', {
    newLink: link
  })
}
export const updateUserLinkApi = ({ user, link }) => {
  return fetchCA(`/links`, { user }, 'PUT', {
    link
  })
}
